import ArticleDetailsForm from './ArticleDetailsForm';

export default ArticleDetailsForm;
